<template>
  <div>
    <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
      Notes
      <template v-if="editable">
        <button class="inline hover:underline text-blue-600 focus:outline-none" @click="addNote">
          add
        </button>
      </template>
    </h5>

    <template v-if="wip.id !== null && isExistingNote === false">
      <div class="shadow-lg rounded mb-4">
        <div class="shadow-xs rounded bg-gray-100 p-4">
          <NoteEditor :content.sync="wip.content" @update="commitChanges" @cancel="cancelEdit" />
        </div>
      </div>
    </template>

    <div class="mt-2 divide-y rounded-lg border overflow-hidden">
      <div v-for="(note, idx) in notes" :key="note.id || idx">
        <div v-if="wip.id === note.id" class="bg-gray-100 p-4">
          <NoteEditor :content.sync="wip.content" @update="commitChanges" @cancel="cancelEdit" />
        </div>

        <div v-else class="px-4 py-3">
          <p class="text-gray-700 text-sm" v-text="note.content" />
          <div v-if="editable" class="mt-4 space-x-2">
            <button
              class="inline hover:underline text-blue-600 text-sm focus:outline-none"
              @click="editNote(note)"
            >
              edit
            </button>
            <button
              class="inline hover:underline text-blue-600 text-sm focus:outline-none"
              @click="removeNote(note)"
            >
              remove
            </button>
          </div>
        </div>
      </div>
      <div v-if="notes.length === 0" class="px-4 py-3 text-sm">
        There are no Notes.
        <template v-if="editable">
          <button class="inline hover:underline text-blue-600 focus:outline-none" @click="addNote">
            Add a note.
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NoteEditor from './relatedNotes/NoteEditor.vue';

const defaultNoteData = {
  id: null,
  content: null,
};

export default {
  name: 'RelatedNotes',

  components: {
    NoteEditor,
  },

  props: {
    editable: Boolean,
    notes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      wip: {
        ...defaultNoteData,
      },
    };
  },

  computed: {
    isExistingNote() {
      if (!this.wip.id) {
        return false;
      }

      return this.notes.findIndex((note) => note.id === this.wip.id) > -1;
    },
  },

  methods: {
    editNote(note) {
      this.wip = JSON.parse(JSON.stringify(note));
    },
    addNote() {
      const newNote = JSON.parse(JSON.stringify(defaultNoteData));
      newNote.id = moment().valueOf();
      this.wip = newNote;
    },
    commitChanges() {
      const newNote = JSON.parse(JSON.stringify(this.wip));

      if (!this.isExistingNote) {
        this.$emit('update:notes', [...this.notes, newNote]);
      } else {
        this.$emit('update:notes', [
          ...this.notes.map((note) => {
            if (note.id !== this.wip.id) {
              return note;
            }

            return newNote;
          }),
        ]);
      }

      this.cancelEdit();
    },
    cancelEdit() {
      this.wip = { ...defaultNoteData };
    },
    removeNote(removeNote) {
      this.$emit('update:notes', [...this.notes.filter((note) => note.id !== removeNote.id)]);
    },
  },
};
</script>
